import { render, staticRenderFns } from "./LanguageSectionEntry.vue?vue&type=template&id=7888eef2&scoped=true"
import script from "./LanguageSectionEntry.vue?vue&type=script&lang=js"
export * from "./LanguageSectionEntry.vue?vue&type=script&lang=js"
import style0 from "./LanguageSectionEntry.vue?vue&type=style&index=0&id=7888eef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888eef2",
  null
  
)

export default component.exports